import React from "react";
import { Link, useLocation } from "react-router-dom";
import DashIcon from "components/icons/DashIcon";
import { useWindowSize } from "hooks/useWindowSize";

export const SidebarLinks = (props: { 
  routes: RoutesType[];
  onLinkClick: () => void;
}): JSX.Element => {
  const location = useLocation();
  const { width } = useWindowSize();
  const { routes, onLinkClick } = props;

  const activeRoute = (routeName: string) => {
    return location.pathname.includes(routeName);
  };

  const handleLinkClick = () => {
    if (width < 1280) {
      onLinkClick();
    }
  };

  const createLinks = (routes: RoutesType[]) => {
    return routes
      .filter(
        (route) =>
          route.layout === "/admin" ||
          route.layout === "/auth" ||
          route.layout === "/rtl"
      )
      .map((route, index) => (
        <Link 
          key={index} 
          to={route.layout + "/" + route.path}
          onClick={handleLinkClick}
        >
          <div className="relative mb-3 flex hover:cursor-pointer">
            <li
              className="my-[3px] flex cursor-pointer items-center px-8"
              key={index}
            >
              <span
                className={`${
                  activeRoute(route.path) === true
                    ? "font-bold text-[#CF4949]"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.icon ? route.icon : <DashIcon />}{" "}
              </span>
              <p
                className={`leading-1 ml-4 flex ${
                  activeRoute(route.path) === true
                    ? "font-bold text-navy-700"
                    : "font-medium text-gray-600"
                }`}
              >
                {route.name}
              </p>
            </li>
            {activeRoute(route.path) ? (
              <div className="absolute right-0 top-px h-9 w-1 rounded-lg bg-[#CF4949] dark:bg-brand-400" />
            ) : null}
          </div>
        </Link>
      ));
  };

  return <>{createLinks(routes)}</>;
};

export default SidebarLinks;
